var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 172,
    viewBox: "0 0 127 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.3457 171.617L-4.40102e-06 100.684L32.6943 100.684L32.6943 -4.10874e-06L93.6475 -1.4444e-06L93.6475 100.684L126.691 100.684L63.3457 171.617Z",
    fill: "url(#paint0_linear_930_6996)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_930_6996",
    x1: 66.4978,
    y1: 156.994,
    x2: 44.2001,
    y2: 43.4393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2876F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886521,
    stopColor: "#DFEBFF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigArrow);
export default __webpack_public_path__ + "static/media/BigArrow.c5f4ce09fdc66b7675e8be49c140a3c8.svg";
export { ForwardRef as ReactComponent };